import React from "react";
import { ProgramTemplateCategory } from "@growth-machine-llc/stridist-api-client";
import { GenericLibraryContextFilter } from "../../filters/GenericLibraryContextFilter";

const getCategoryLabel = (category: ProgramTemplateCategory): string => {
  if (category === ProgramTemplateCategory.NONE) return "None";
  return category
    .split("_")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
};

const ProgramTemplateCategoryLabels = Object.values(
  ProgramTemplateCategory,
).reduce(
  (acc, category) => {
    acc[category] = getCategoryLabel(category);
    return acc;
  },
  {} as Record<ProgramTemplateCategory, string>,
);

export const CategoryFilter = React.memo(function CategoryFilter({
  onChange,
  contextFilters,
  className,
}: {
  onChange?: (selected: ProgramTemplateCategory[]) => void;
  contextFilters?: ProgramTemplateCategory[];
  className?: string;
}) {
  return (
    <GenericLibraryContextFilter
      enumType={ProgramTemplateCategory}
      filterTypesLabels={ProgramTemplateCategoryLabels}
      labelType="Type"
      contextFilters={contextFilters}
      onChange={onChange}
      className={className}
    />
  );
});
